/** Table with a selectable row (lavender frame) for the leads and approvals screens: the first column is a button, the detail shows in an aside. */
import type { ReactNode } from 'react';
import './customer.css';

export interface SelectColumn<R> { key: string; header: string; render: (r: R) => ReactNode; primary?: boolean }

export function SelectTable<R extends { id: string }>({ caption, columns, rows, selected, onSelect }: {
  caption: string; columns: SelectColumn<R>[]; rows: R[]; selected: string | null; onSelect: (id: string) => void;
}) {
  return (
    <div className="cu-table-wrap">
      <table className="cu-table">
        <caption className="qm-sr-only">{caption}</caption>
        <thead><tr>{columns.map((c) => <th key={c.key} scope="col">{c.header}</th>)}</tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className={selected === r.id ? 'qs-selected' : undefined} aria-current={selected === r.id ? 'true' : undefined}>
              {columns.map((c) => (
                <td key={c.key} data-label={c.header}>
                  {c.primary ? <button type="button" className="cu-rowbtn" aria-pressed={selected === r.id} onClick={() => onSelect(r.id)}>{c.render(r)}</button> : c.render(r)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Distinct non-empty values of a field, sorted, for filter options. */
export const distinct = (rows: readonly Record<string, unknown>[], key: string): string[] => [...new Set(rows.map((r) => (r[key] == null ? '' : String(r[key]))).filter(Boolean))].sort();
